import gql from "graphql-tag";

export const CREATE_ATTACHMENT = gql`
  mutation AddAttachment($data: AttachmentDataInput) {
    addAttachment(data: $data) {
      id
      key
      name
      fileUrl
      contentType
      type
      filename
      user {
        id
      }
    }
  }
`;

export const GENERATE_SUBSCRIPTION_DOCUMENTS = gql`
  mutation generateSubscriptionDocuments($data: SubscriptionWhereInput) {
    generateSubscriptionDocuments(data: $data) {
      base64
      attachments {
        id
        type
      }
    }
  }
`;

export const GENERATE_QUOTE_DOCUMENTS = gql`
  mutation GenerateQuoteDocuments($data: GenerateQuoteDocumentsDataInput) {
    generateQuoteDocuments(data: $data) {
      base64
      attachments {
        id
      }
    }
  }
`;

export const GENERATE_ZIP_DOCUMENT = gql`
  mutation GenerateZipDocuments($where: AttachmentWhereInput) {
    generateZipDocuments(where: $where) {
      fileUrl
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation DeleteAttachment($where: AttachmentWhereInput) {
    deleteAttachment(where: $where) {
      id
    }
  }
`;

export const UNLINK_ATTACHMENT_FROM_INSURANCE_PLAN = gql`
  mutation UnlinkAttachmentFromInsurancePlan(
    $where: AttachmentWhereInput!
    $insurancePlanId: String!
  ) {
    unlinkAttachmentFromInsurancePlan(
      where: $where
      insurancePlanId: $insurancePlanId
    ) {
      id
    }
  }
`;

const attachments = {
  CREATE_ATTACHMENT,
  DELETE_ATTACHMENT,
  UNLINK_ATTACHMENT_FROM_INSURANCE_PLAN,
  GENERATE_SUBSCRIPTION_DOCUMENTS,
  GENERATE_QUOTE_DOCUMENTS,
  GENERATE_ZIP_DOCUMENT,
};

export default attachments;
